module.exports = __webpack_public_path__ + "flyer_layout_center_shape_blur_shape-595399dac407dfe5c93dbd027674fedc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Layouts/Flourishes/flyer_layout_center_shape_blur_shape.png
// module id = 1574
// module chunks = 1